import React from 'react'
import createReactClass from 'create-react-class'
import './info-panel.scss'

export default createReactClass({
  onCloseButtonClick () {
    clearTimeout(this.timeout)
    this.timeout = null
    if (this.infoAlertNode) {
      this.infoAlertNode.classList.add('fadeOut')
    }
    this.props.resetInfoObject()
  },

  render () {
    let {error, message} = this.props.infoObj
    if (error || message) {
      return (
        <div className={error ? 'info-alert error' : 'info-alert'} ref={(node) => {
          this.infoAlertNode = node
        }}>
          <div className='close-button' onClick={this.onCloseButtonClick}>x</div>
          <div className='info-alert-message'>{message}</div>
        </div>
      )
    }
    return false
  },

  componentDidUpdate () {
    if ((this.props.infoObj.error || this.props.infoObj.message) && !this.timeout) {
      this.timeout = setTimeout(this.onCloseButtonClick, 5000)
    }
  },

  componentWillUnmount () {
    clearTimeout(this.timeout)
  },
})



// WEBPACK FOOTER //
// ./src/components/info-panel.js